<template>
	<DaModalFrame v-model:open="modalIsOpen">
		<ChooseCenter
			:htcs="true"
			:listCenter="listCenter"
			:selectedOrg="selectedOrg"
			@change-center="fetchData"
		/>
	</DaModalFrame>
	<div class="__report-lesson px-12 md-down:px-4 pb-30">
		<div
			class="
				__report-lesson__header
				pt-10
				pb-10
				flex flex-nowrap
				justify-between
				items-center
			"
		>
			<div
				class="
					__record__title
					text-neutral-500
					font-semibold
					whitespace-nowrap
					flex flex-nowrap
					items-center
					text-4xl
				"
			>
				<svg
					class="mr-3 h-6 w-6"
					viewBox="0 0 28 28"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M19.25 3.5C19.25 2.5335 20.0335 1.75 21 1.75H24.5C25.4665 1.75 26.25 2.5335 26.25 3.5V24.5H27.125C27.6082 24.5 28 24.8918 28 25.375C28 25.8582 27.6082 26.25 27.125 26.25H0.875C0.391751 26.25 0 25.8582 0 25.375C0 24.8918 0.391751 24.5 0.875 24.5H1.75V19.25C1.75 18.2835 2.5335 17.5 3.5 17.5H7C7.9665 17.5 8.75 18.2835 8.75 19.25V24.5H10.5V12.25C10.5 11.2835 11.2835 10.5 12.25 10.5H15.75C16.7165 10.5 17.5 11.2835 17.5 12.25V24.5H19.25V3.5Z"
						fill="#94A3B8"
					/>
				</svg>

				Thống Kê Tổng Quan
			</div>
			<div class="input-group">
				<VueDatepicker
					class="input-date w-full"
					placeholder="Chọn tháng"
					uid="filter-by-date"
					v-model="date"
					auto-apply
					month-picker
					format="MM/yyyy"
					:min-date="new Date(2022, 10, 1)"
					:max-date="new Date()"
				>
					<template #input-icon>
						<svg
							width="20"
							height="20"
							viewBox="0 0 20 20"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M5 0.625C5 0.279822 4.72018 0 4.375 0C4.02982 0 3.75 0.279822 3.75 0.625V1.25H2.5C1.11929 1.25 0 2.36929 0 3.75V5H20V3.75C20 2.36929 18.8807 1.25 17.5 1.25H16.25V0.625C16.25 0.279822 15.9702 0 15.625 0C15.2798 0 15 0.279822 15 0.625V1.25H5V0.625ZM20 17.5V6.25H0V17.5C0 18.8807 1.11929 20 2.5 20H17.5C18.8807 20 20 18.8807 20 17.5ZM11.875 8.75C11.5298 8.75 11.25 9.02982 11.25 9.375V10.625C11.25 10.9702 11.5298 11.25 11.875 11.25H13.125C13.4702 11.25 13.75 10.9702 13.75 10.625V9.375C13.75 9.02982 13.4702 8.75 13.125 8.75H11.875ZM15.625 8.75C15.2798 8.75 15 9.02982 15 9.375V10.625C15 10.9702 15.2798 11.25 15.625 11.25H16.875C17.2202 11.25 17.5 10.9702 17.5 10.625V9.375C17.5 9.02982 17.2202 8.75 16.875 8.75H15.625ZM2.5 13.125C2.5 12.7798 2.77982 12.5 3.125 12.5H4.375C4.72018 12.5 5 12.7798 5 13.125V14.375C5 14.7202 4.72018 15 4.375 15H3.125C2.77982 15 2.5 14.7202 2.5 14.375V13.125ZM6.875 12.5C6.52982 12.5 6.25 12.7798 6.25 13.125V14.375C6.25 14.7202 6.52982 15 6.875 15H8.125C8.47018 15 8.75 14.7202 8.75 14.375V13.125C8.75 12.7798 8.47018 12.5 8.125 12.5H6.875Z"
								fill="#94A3B8"
							/>
						</svg>
					</template>
				</VueDatepicker>
			</div>
		</div>
		<div class="w-full mb-6 flex gap-6 items-stretch">
			<div class="w-2/3 rounded-lg overflow-hidden" style="height: 620px">
				<div class="w-full relative h-full">
					<img
						class="w-full h-full object-cover"
						src="@/assets/images/illustrations/htcs.jpg"
						alt=""
					/>
					<div class="absolute top-0 w-full p-4">
						<div class="flex items-center gap-4 justify-end">
							<div>
								<div class="text-neutral-700 text-sm">
									Tổng số cơ sở
								</div>
								<div
									class="
										font-semibold
										text-33 text-neutral-600
									"
								>
									{{ orgCount }}
								</div>
							</div>
							<div>
								<div class="text-neutral-700 text-sm">
									Tổng số học sinh
								</div>
								<div
									class="
										font-semibold
										text-33 text-neutral-600
									"
								>
									{{ studentCount }}
								</div>
							</div>
						</div>
					</div>
					<div class="absolute bottom-0 w-full p-4">
						<div class="text-neutral-700 text-sm mb-2">
							Hệ thống cơ sở
						</div>
						<div
							class="font-semibold text-neutral-600 text-lg mb-2"
						>
							{{ orgName }}
						</div>
						<div class="flex items-center gap-2">
							<a
								href="https://docs.google.com/forms/d/e/1FAIpQLSdUMD2rQS42UVHImF5g9lZqwOUyeBJ6ohwPZgOMsHyq2JmNfg/viewform"
								target="_blank"
								class="button-p text-center w-max px-4"
							>
								Đăng ký cơ sở mới
							</a>
							<button
								type="button"
								class="button-p text-center w-max px-4 bg-white"
								@click="$router.push('/dashboard-stats-chart')"
							>
								Xem biểu đồ thống kê
							</button>
						</div>
					</div>
				</div>
			</div>
			<div class="w-1/3 rounded-lg overflow-hidden">
				<div
					class="opacity-100 bg-white shadow-sm h-full flex flex-col"
				>
					<div class="flex items-center justify-between border-b p-4">
						<div class="text-neutral-600 font-semibold">
							Kết quả học tập toàn cơ sở
						</div>
						<button
							type="button"
							class="button-p text-center w-max bg-white"
							@click="$router.push('/dashboard-stats-chart')"
						>
							Xem tất cả
						</button>
					</div>
					<div class="p-4">
						<BaseStackedBarChart
							:series="assessmentStats?.assessmentByResult?.data"
							:categories="
								assessmentStats?.assessmentByResult?.xAxis
							"
							:colors="[
								'#F87171',
								'#FBBF24',
								'#84CC16',
								'#2AA797',
							]"
							:showLegend="false"
							:yaxisMax="100"
						/>
					</div>
				</div>
			</div>
		</div>
		<div
			class="
				grid grid-cols-1
				lg:grid-cols-4 sm:grid-cols-2
				md:grid-cols-3
				gap-4
				w-full
				mb-10
			"
		>
			<div v-for="(city, index) in listCity" :key="index">
				<div class="shadow-sm p-4 flex items-center gap-2">
					<svg
						width="56"
						height="56"
						viewBox="0 0 56 56"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect
							width="56"
							height="56"
							rx="8"
							:fill="colorByIndex(index).light"
						/>
						<path
							d="M37 35H39V37H17V35H19V20C19 19.7348 19.1054 19.4804 19.2929 19.2929C19.4804 19.1054 19.7348 19 20 19H30C30.2652 19 30.5196 19.1054 30.7071 19.2929C30.8946 19.4804 31 19.7348 31 20V35H33V25H36C36.2652 25 36.5196 25.1054 36.7071 25.2929C36.8946 25.4804 37 25.7348 37 26V35ZM23 27V29H27V27H23ZM23 23V25H27V23H23Z"
							:fill="colorByIndex(index).solid"
						/>
					</svg>
					<div>
						<div class="text-neutral-500">
							<span class="text-neutral-600">{{
								city.number
							}}</span>
							cơ sở
						</div>
						<div class="text-neutral-600">tại {{ city.city }}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="w-full mb-10">
			<div class="relative">
				<div
					class="absolute inset-0 flex items-center"
					aria-hidden="true"
				>
					<div class="w-full border-t border-neutral-300" />
				</div>
				<div class="relative flex justify-center">
					<div
						class="
							bg-body
							px-2
							text-neutral-600
							font-semibold
							whitespace-nowrap
							flex flex-nowrap
							items-center
							text-2xl
							justify-center
							gap-2
							cursor-pointer
						"
						@click="modalIsOpen = true"
					>
						<div>
							{{
								selectedOrg
									? selectedOrg.name
									: 'Hệ thống cơ sở'
							}}
						</div>
						<DaIcon
							class="h-4 w-4 transform arrow--icon-menu"
							name="das--chevron-down"
						/>
					</div>
				</div>
			</div>
			<div class="mt-10 grid grid-cols-1 lg:grid-cols-4 gap-4 w-full">
				<div class="col-span-3">
					<div class="flex items-center justify-between mb-4">
						<div class="text-neutral-600 font-semibold text-lg">
							Theo dõi học sinh
						</div>
					</div>
					<div
						class="flex items-stretch gap-4 w-full sm-down:flex-col"
					>
						<div
							class="
								px-6
								py-4
								rounded-lg
								bg-green-500
								flex flex-col
								items-start
								justify-between
								text-neutral-700
								w-full
							"
						>
							<div class="flex items-start justify-start gap-4">
								<div>
									<svg
										width="20"
										height="20"
										viewBox="0 0 20 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<g clip-path="url(#clip0_13832_6866)">
											<path
												d="M7 9.75C6.31 9.75 5.75 10.31 5.75 11C5.75 11.69 6.31 12.25 7 12.25C7.69 12.25 8.25 11.69 8.25 11C8.25 10.31 7.69 9.75 7 9.75ZM13 9.75C12.31 9.75 11.75 10.31 11.75 11C11.75 11.69 12.31 12.25 13 12.25C13.69 12.25 14.25 11.69 14.25 11C14.25 10.31 13.69 9.75 13 9.75ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 9.71 2.02 9.42 2.05 9.14C4.41 8.09 6.28 6.16 7.26 3.77C9.07 6.33 12.05 8 15.42 8C16.2 8 16.95 7.91 17.67 7.74C17.88 8.45 18 9.21 18 10C18 14.41 14.41 18 10 18Z"
												fill="currentColor"
											/>
											<path
												d="M8 13.9895C8 13.9895 9.86667 18.4895 12 13.9895H8Z"
												fill="currentColor"
											/>
										</g>
									</svg>
								</div>
								<div>Học sinh đang học</div>
							</div>
							<div class="text-4xl font-bold mt-4">
								{{ data.student_stats.active_student_count }}
							</div>
						</div>
						<div
							class="
								px-6
								py-4
								rounded-lg
								bg-yellow-400
								flex flex-col
								items-start
								justify-between
								text-neutral-700
								w-full
							"
						>
							<div class="flex items-start justify-start gap-4">
								<div>
									<svg
										width="20"
										height="20"
										viewBox="0 0 20 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<g clip-path="url(#clip0_13832_6866)">
											<path
												d="M7 9.75C6.31 9.75 5.75 10.31 5.75 11C5.75 11.69 6.31 12.25 7 12.25C7.69 12.25 8.25 11.69 8.25 11C8.25 10.31 7.69 9.75 7 9.75ZM13 9.75C12.31 9.75 11.75 10.31 11.75 11C11.75 11.69 12.31 12.25 13 12.25C13.69 12.25 14.25 11.69 14.25 11C14.25 10.31 13.69 9.75 13 9.75ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 9.71 2.02 9.42 2.05 9.14C4.41 8.09 6.28 6.16 7.26 3.77C9.07 6.33 12.05 8 15.42 8C16.2 8 16.95 7.91 17.67 7.74C17.88 8.45 18 9.21 18 10C18 14.41 14.41 18 10 18Z"
												fill="currentColor"
											/>
											<path
												d="M8 13.9895C8 13.9895 9.86667 18.4895 12 13.9895H8Z"
												fill="currentColor"
											/>
										</g>
									</svg>
								</div>
								<div>Học sinh mới nhập học</div>
							</div>
							<div class="text-4xl font-bold mt-4">
								{{
									data.student_stats.just_joined_student_count
								}}
							</div>
						</div>
						<div
							class="
								px-6
								py-4
								rounded-lg
								bg-sienna-500
								flex flex-col
								items-start
								justify-between
								text-neutral-700
								w-full
							"
						>
							<div class="flex items-start justify-start gap-4">
								<div>
									<svg
										width="20"
										height="20"
										viewBox="0 0 20 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<g clip-path="url(#clip0_13832_6866)">
											<path
												d="M7 9.75C6.31 9.75 5.75 10.31 5.75 11C5.75 11.69 6.31 12.25 7 12.25C7.69 12.25 8.25 11.69 8.25 11C8.25 10.31 7.69 9.75 7 9.75ZM13 9.75C12.31 9.75 11.75 10.31 11.75 11C11.75 11.69 12.31 12.25 13 12.25C13.69 12.25 14.25 11.69 14.25 11C14.25 10.31 13.69 9.75 13 9.75ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 9.71 2.02 9.42 2.05 9.14C4.41 8.09 6.28 6.16 7.26 3.77C9.07 6.33 12.05 8 15.42 8C16.2 8 16.95 7.91 17.67 7.74C17.88 8.45 18 9.21 18 10C18 14.41 14.41 18 10 18Z"
												fill="currentColor"
											/>
											<path
												d="M8 13.9895C8 13.9895 9.86667 18.4895 12 13.9895H8Z"
												fill="currentColor"
											/>
										</g>
									</svg>
								</div>
								<div>Học sinh đã tốt nghiệp trong tháng</div>
							</div>
							<div class="text-4xl font-bold mt-4">
								{{ data.student_stats.closed_student_count }}
							</div>
						</div>
					</div>
				</div>
				<div class="flex flex-col col-span-3 sm:col-span-1 sm:w-full">
					<div class="flex items-center justify-between mb-4">
						<div class="text-neutral-600 font-semibold text-lg">
							Giáo viên
						</div>
					</div>
					<div class="flex items-start gap-4 h-full w-full">
						<div
							class="
								w-full
								h-full
								text-neutral-500
								px-6
								py-4
								rounded-lg
								bg-white
								shadow
								border-sm
								flex flex-col
								items-start
								justify-between
							"
						>
							<div class="flex items-start justify-start gap-4">
								<div>
									<svg
										width="20"
										height="20"
										viewBox="0 0 20 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M8.75 17.5C8.75 17.5 7.5 17.5 7.5 16.25C7.5 15 8.75 11.25 13.75 11.25C18.75 11.25 20 15 20 16.25C20 17.5 18.75 17.5 18.75 17.5H8.75Z"
											fill="#2AA797"
										/>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M13.75 10C15.8211 10 17.5 8.32107 17.5 6.25C17.5 4.17893 15.8211 2.5 13.75 2.5C11.6789 2.5 10 4.17893 10 6.25C10 8.32107 11.6789 10 13.75 10Z"
											fill="#2AA797"
										/>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M6.52045 17.5C6.34445 17.1449 6.25 16.7239 6.25 16.25C6.25 14.5557 7.09882 12.8132 8.66991 11.6C7.98262 11.3801 7.18137 11.25 6.25 11.25C1.25 11.25 0 15 0 16.25C0 17.5 1.25 17.5 1.25 17.5H6.52045Z"
											fill="#2AA797"
										/>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M5.625 10C7.35089 10 8.75 8.60089 8.75 6.875C8.75 5.14911 7.35089 3.75 5.625 3.75C3.89911 3.75 2.5 5.14911 2.5 6.875C2.5 8.60089 3.89911 10 5.625 10Z"
											fill="#2AA797"
										/>
									</svg>
								</div>
								<div>Số GV đang dạy</div>
							</div>
							<div
								class="text-4xl font-bold mt-4 text-neutral-600"
							>
								{{ data.staff_stats.active_staff_count }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="mt-10">
				<div class="bg-white shadow border-sm p-6 rounded-lg">
					<div class="text-neutral-600 font-semibold text-lg">
						Kết quả học tập
					</div>
					<div class="relative mt-6 flex items-center">
						<div class="h-full mr-10 pt-6">
							<div
								style="height: 200px"
								class="
									flex flex-col
									items-start
									justify-between
								"
							>
								<div
									class="
										w-full
										rounded-full
										text-center text-white text-sm
										font-semibold
										py-1
										px-4
										whitespace-nowrap
									"
									style="background: #2aa797"
								>
									Đạt > 75%
								</div>
								<div
									class="
										w-full
										rounded-full
										text-center text-white text-sm
										font-semibold
										py-1
										px-4
										whitespace-nowrap
									"
									style="background: #65a30d"
								>
									Đạt 55-75%
								</div>
								<div
									class="
										w-full
										rounded-full
										text-center text-white text-sm
										font-semibold
										py-1
										px-4
										whitespace-nowrap
									"
									style="background: #f59e0b"
								>
									Đạt 25-55%
								</div>
								<div
									class="
										w-full
										rounded-full
										text-center text-white text-sm
										font-semibold
										py-1
										px-4
										whitespace-nowrap
									"
									style="background: #f87171"
								>
									Đạt &lt; 25%
								</div>
							</div>

							<div
								class="
									text-neutral-500 text-sm
									mt-8
									font-medium
									whitespace-nowrap
								"
							>
								Số học sinh (%)
							</div>
						</div>
						<div class="w-full grid grid-cols-10 pt-6 relative">
							<div
								class="
									absolute
									l-0
									pt-8
									w-full
									flex flex-col
									items-start
									justify-between
								"
								style="height: 216px"
							>
								<div
									:style="{
										width:
											data.assessment_stats
												.assessment_more_than_seventy_percent +
											'%',
									}"
									style="
										height: 15px;
										background: #2aa797;
										border-radius: 0 99px 99px 0;
									"
								></div>
								<div
									:style="{
										width:
											data.assessment_stats
												.assessment_less_than_seventy_percent +
											'%',
									}"
									style="
										height: 15px;
										background: #65a30d;
										border-radius: 0 99px 99px 0;
									"
								></div>
								<div
									:style="{
										width:
											data.assessment_stats
												.assessment_less_than_sixty_percent +
											'%',
									}"
									style="
										height: 15px;
										background: #f59e0b;
										border-radius: 0 99px 99px 0;
									"
								></div>
								<div
									:style="{
										width:
											data.assessment_stats
												.assessment_less_than_fifty_percent +
											'%',
									}"
									style="
										height: 15px;
										background: #f87171;
										border-radius: 0 99px 99px 0;
									"
								></div>
							</div>
							<div v-for="i in 10" :key="i">
								<div
									class="
										border
										border-t-0
										border-b-0
										border-l
										border-neutral-200
									"
									:class="{ 'border-r-0': i !== 10 }"
									style="height: 200px"
								></div>
								<div
									class="
										text-neutral-500 text-sm
										mt-8
										font-semibold
										float-right
										-mr-2
									"
								>
									{{ i * 10 }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="mt-10" v-if="isEnableSchedule || hasDaycare">
				<div class="text-neutral-600 font-semibold text-lg mb-4">
					Can thiệp cá nhân
				</div>
				<div class="bg-white shadow border-sm rounded-lg">
					<div class="flex items-center justify-between p-6 border-b">
						<div class="text-neutral-600 font-semibold text-lg">
							Chuyên cần
						</div>
					</div>
					<div class="grid grid-cols-1 lg:grid-cols-3">
						<div
							class="
								flex
								items-center
								justify-between
								border-r
								p-6
							"
						>
							<div class="flex items-center justify-start gap-2">
								<div>
									<svg
										width="20"
										height="20"
										viewBox="0 0 20 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10 4.375C10 4.02982 9.72018 3.75 9.375 3.75C9.02982 3.75 8.75 4.02982 8.75 4.375V11.25C8.75 11.4743 8.87018 11.6814 9.06491 11.7927L13.4399 14.2927C13.7396 14.4639 14.1214 14.3598 14.2927 14.0601C14.4639 13.7604 14.3598 13.3786 14.0601 13.2073L10 10.8873V4.375Z"
											fill="#6366F1"
										/>
									</svg>
								</div>
								<div>Giờ học thực tế / dự kiến</div>
							</div>
							<div class="text-3xl font-bold text-neutral-600">
								{{
									data.session_stats
										?.total_non_cancelled_hours
								}}/
								{{ data.session_stats?.total_scheduled_hours }}
							</div>
						</div>
						<div
							class="
								flex
								items-center
								justify-between
								border-r
								p-6
							"
						>
							<div class="flex items-center justify-start gap-2">
								<div>
									<svg
										width="24"
										height="20"
										viewBox="0 0 24 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M15.1868 2.64138C13.6109 1.50371 11.6754 0.833328 9.58333 0.833328C4.2906 0.833328 0 5.12393 0 10.4167C0 15.7094 4.2906 20 9.58333 20C14.8761 20 19.1667 15.7094 19.1667 10.4167C19.1667 9.90392 19.1264 9.40058 19.0489 8.90964C16.7423 8.46543 15 6.43618 15 3.99999C15 3.52908 15.0651 3.07337 15.1868 2.64138ZM8.98438 4.42708C9.31517 4.42708 9.58333 4.69524 9.58333 5.02604V11.267L13.4743 13.4904C13.7615 13.6545 13.8612 14.0204 13.6971 14.3076C13.533 14.5948 13.1671 14.6946 12.8799 14.5305L8.68721 12.1346C8.50059 12.028 8.38542 11.8295 8.38542 11.6146V5.02604C8.38542 4.69524 8.65358 4.42708 8.98438 4.42708Z"
											fill="#E68D7B"
										/>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M20 8C22.2091 8 24 6.20914 24 4C24 1.79086 22.2091 0 20 0C17.7909 0 16 1.79086 16 4C16 6.20914 17.7909 8 20 8ZM17.8333 4C17.8333 3.72386 18.0571 3.5 18.3333 3.5H21.8333C22.1094 3.5 22.3333 3.72386 22.3333 4C22.3333 4.27614 22.1094 4.5 21.8333 4.5H18.3333C18.0571 4.5 17.8333 4.27614 17.8333 4Z"
											fill="#E68D7B"
										/>
									</svg>
								</div>
								<div>Giờ học báo nghỉ</div>
							</div>
							<div class="text-3xl font-bold text-neutral-600">
								{{ data.session_stats?.total_cancelled_hours }}
							</div>
						</div>
						<div class="flex items-center justify-between p-6">
							<div class="flex items-center justify-start gap-2">
								<div>
									<svg
										width="24"
										height="20"
										viewBox="0 0 24 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M20 8C22.2091 8 24 6.20914 24 4C24 1.79086 22.2091 0 20 0C17.7909 0 16 1.79086 16 4C16 6.20914 17.7909 8 20 8ZM20 1.16667C20.2761 1.16667 20.5 1.39052 20.5 1.66667V3.5H22.3333C22.6095 3.5 22.8333 3.72386 22.8333 4C22.8333 4.27614 22.6095 4.5 22.3333 4.5H20.5V6.33333C20.5 6.60948 20.2761 6.83333 20 6.83333C19.7239 6.83333 19.5 6.60948 19.5 6.33333V4.5H17.6667C17.3905 4.5 17.1667 4.27614 17.1667 4C17.1667 3.72386 17.3905 3.5 17.6667 3.5H19.5V1.66667C19.5 1.39052 19.7239 1.16667 20 1.16667Z"
											fill="#F1A267"
										/>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M15.1868 2.64138C13.6109 1.50371 11.6754 0.833328 9.58333 0.833328C4.2906 0.833328 0 5.12393 0 10.4167C0 15.7094 4.2906 20 9.58333 20C14.8761 20 19.1667 15.7094 19.1667 10.4167C19.1667 9.90392 19.1264 9.40058 19.0489 8.90964C16.7423 8.46543 15 6.43618 15 3.99999C15 3.52908 15.0651 3.07337 15.1868 2.64138ZM8.98438 4.42708C9.31517 4.42708 9.58333 4.69524 9.58333 5.02604V11.267L13.4743 13.4904C13.7615 13.6545 13.8612 14.0204 13.6971 14.3076C13.533 14.5948 13.1671 14.6946 12.8799 14.5305L8.68721 12.1346C8.50059 12.028 8.38542 11.8295 8.38542 11.6146V5.02604C8.38542 4.69524 8.65358 4.42708 8.98438 4.42708Z"
											fill="#F1A267"
										/>
									</svg>
								</div>
								<div>Giờ học phát sinh</div>
							</div>
							<div class="text-3xl font-bold text-neutral-600">
								{{
									data.session_stats?.total_unscheduled_hours
								}}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="mt-6">
				<div class="grid grid-cols-1 xl:grid-cols-2 gap-6">
					<div class="bg-white shadow border-sm rounded-lg">
						<div class="border-b">
							<div
								class="
									text-neutral-500
									font-semibold
									border-b
									p-6
								"
							>
								Tỉ lệ hoàn thành báo cáo
							</div>
							<div
								class="
									relative
									p-6
									flex
									items-center
									text-neutral-500
									gap-4
								"
							>
								<div class="h-full pb-9">
									<div
										style="height: 200px"
										class="
											flex flex-col
											items-start
											justify-between
										"
									>
										<div
											class="
												w-full
												rounded-full
												text-sm
												whitespace-nowrap
											"
										>
											<div>BC ngày</div>
											<div class="font-bold">
												{{
													data.report_stats
														?.lesson_report_stats
														?.completed_lesson_report_percent
												}}%
											</div>
										</div>
										<div
											class="
												w-full
												rounded-full
												text-sm
												whitespace-nowrap
											"
										>
											<div>BC tuần</div>
											<div class="font-bold">
												{{
													data.report_stats
														?.weekly_report_stats
														?.weekly_report_completed_percent
												}}%
											</div>
										</div>
										<div
											class="
												w-full
												rounded-full
												text-sm
												whitespace-nowrap
											"
										>
											<div>BCKH</div>
											<div class="font-bold">
												{{
													data.report_stats
														?.monthly_report_stats
														?.monthly_report_completed_percent
												}}%
											</div>
										</div>
									</div>
								</div>
								<div
									class="
										w-full
										grid grid-cols-10
										pt-6
										relative
									"
								>
									<div
										class="
											absolute
											l-0
											pt-8
											w-full
											flex flex-col
											items-start
											justify-between
										"
										style="height: 216px"
									>
										<div
											:style="{
												width:
													data.report_stats
														?.lesson_report_stats
														?.completed_lesson_report_percent +
													'%',
												background: $filters.tagResult(
													data.report_stats
														?.lesson_report_stats
														?.completed_lesson_report_percent
												)?.background,
											}"
											style="
												height: 15px;
												border-radius: 0 99px 99px 0;
											"
										></div>
										<div
											:style="{
												width:
													data.report_stats
														?.weekly_report_stats
														?.weekly_report_completed_percent +
													'%',
												background: $filters.tagResult(
													data.report_stats
														?.weekly_report_stats
														?.weekly_report_completed_percent
												)?.background,
											}"
											style="
												height: 15px;
												border-radius: 0 99px 99px 0;
											"
										></div>
										<div
											:style="{
												width:
													data.report_stats
														?.monthly_report_stats
														?.monthly_report_completed_percent +
													'%',
												background: $filters.tagResult(
													data.report_stats
														?.monthly_report_stats
														?.monthly_report_completed_percent
												)?.background,
											}"
											style="
												height: 15px;
												border-radius: 0 99px 99px 0;
											"
										></div>
									</div>
									<div v-for="i in 10" :key="i">
										<div
											class="
												border
												border-t-0
												border-b-0
												border-l
												border-neutral-200
											"
											:class="{ 'border-r-0': i !== 10 }"
											style="height: 200px"
										></div>
										<div
											class="
												text-neutral-500 text-sm
												mt-8
												font-semibold
												float-right
												-mr-2
											"
										>
											{{ i * 10 }}
										</div>
									</div>
								</div>
								<div class="h-full pb-8">
									<div
										style="height: 200px"
										class="
											flex flex-col
											items-start
											justify-between
										"
									>
										<div
											class="
												w-full
												text-sm
												py-1
												whitespace-nowrap
												font-bold
											"
										>
											{{
												data.report_stats
													?.lesson_report_stats
													?.completed_lesson_report_count
											}}/{{
												data.report_stats
													?.lesson_report_stats
													?.total_lesson_report_count
											}}
										</div>
										<div
											class="
												w-full
												text-sm
												py-1
												whitespace-nowrap
												font-bold
											"
										>
											{{
												data.report_stats
													?.weekly_report_stats
													?.completed_weekly_report_count
											}}/{{
												data.report_stats
													?.weekly_report_stats
													?.schedule_weekly_report_count
											}}
										</div>
										<div
											class="
												w-full
												text-sm
												py-1
												whitespace-nowrap
												font-bold
											"
										>
											{{
												data.report_stats
													?.monthly_report_stats
													?.completed_monthly_report_count
											}}/{{
												data.report_stats
													?.monthly_report_stats
													?.schedule_monthly_report_count
											}}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="bg-white shadow border-sm rounded-lg">
						<div class="border-b">
							<div
								class="
									text-neutral-500
									font-semibold
									border-b
									p-6
								"
							>
								Tỉ lệ phụ huynh xem báo cáo
							</div>
							<div
								class="
									relative
									p-6
									flex
									items-center
									text-neutral-500
									gap-4
								"
							>
								<div class="h-full pb-9">
									<div
										style="height: 200px"
										class="
											flex flex-col
											items-start
											justify-between
										"
									>
										<div
											class="
												w-full
												rounded-full
												text-sm
												whitespace-nowrap
											"
										>
											<div>BC ngày</div>
											<div class="font-bold">
												{{
													data.report_stats
														?.lesson_report_stats
														?.parent_read_report_percent
												}}%
											</div>
										</div>
										<div
											class="
												w-full
												rounded-full
												text-sm
												whitespace-nowrap
											"
										>
											<div>BC tuần</div>
											<div class="font-bold">
												{{
													data.report_stats
														?.weekly_report_stats
														?.parent_read_report_percent
												}}%
											</div>
										</div>
										<div
											class="
												w-full
												rounded-full
												text-sm
												whitespace-nowrap
											"
										>
											<div>BCKH</div>
											<div class="font-bold">
												{{
													data.report_stats
														?.monthly_report_stats
														?.parent_read_monthy_reports_percent
												}}%
											</div>
										</div>
									</div>
								</div>
								<div
									class="
										w-full
										grid grid-cols-10
										pt-6
										relative
									"
								>
									<div
										class="
											absolute
											l-0
											pt-8
											w-full
											flex flex-col
											items-start
											justify-between
										"
										style="height: 216px"
									>
										<div
											:style="{
												width:
													data.report_stats
														?.lesson_report_stats
														?.parent_read_report_percent +
													'%',
												background: $filters.tagResult(
													data.report_stats
														?.lesson_report_stats
														?.parent_read_report_percent
												)?.background,
											}"
											style="
												height: 15px;
												border-radius: 0 99px 99px 0;
											"
										></div>
										<div
											:style="{
												width:
													data.report_stats
														?.weekly_report_stats
														?.parent_read_report_percent +
													'%',
												background: $filters.tagResult(
													data.report_stats
														?.weekly_report_stats
														?.parent_read_report_percent
												)?.background,
											}"
											style="
												height: 15px;
												border-radius: 0 99px 99px 0;
											"
										></div>
										<div
											:style="{
												width:
													data.report_stats
														?.monthly_report_stats
														?.parent_read_monthy_reports_percent +
													'%',
												background: $filters.tagResult(
													data.report_stats
														?.monthly_report_stats
														?.parent_read_monthy_reports_percent
												)?.background,
											}"
											style="
												height: 15px;
												border-radius: 0 99px 99px 0;
											"
										></div>
									</div>
									<div v-for="i in 10" :key="i">
										<div
											class="
												border
												border-t-0
												border-b-0
												border-l
												border-neutral-200
											"
											:class="{ 'border-r-0': i !== 10 }"
											style="height: 200px"
										></div>
										<div
											class="
												text-neutral-500 text-sm
												mt-8
												font-semibold
												float-right
												-mr-2
											"
										>
											{{ i * 10 }}
										</div>
									</div>
								</div>
								<div class="h-full pb-8">
									<div
										style="height: 200px"
										class="
											flex flex-col
											items-start
											justify-between
										"
									>
										<div
											class="
												w-full
												text-sm
												py-1
												whitespace-nowrap
												font-bold
											"
										>
											{{
												data.report_stats
													?.lesson_report_stats
													?.total_parent_read_report
											}}/{{
												data.report_stats
													?.lesson_report_stats
													?.total_lesson_report_count
											}}
										</div>
										<div
											class="
												w-full
												text-sm
												py-1
												whitespace-nowrap
												font-bold
											"
										>
											{{
												data.report_stats
													?.weekly_report_stats
													?.total_parent_read_report
											}}/{{
												data.report_stats
													?.weekly_report_stats
													?.schedule_weekly_report_count
											}}
										</div>
										<div
											class="
												w-full
												text-sm
												py-1
												whitespace-nowrap
												font-bold
											"
										>
											{{
												data.report_stats
													?.monthly_report_stats
													?.total_parent_read_monthy_reports
											}}/{{
												data.report_stats
													?.monthly_report_stats
													?.schedule_monthly_report_count
											}}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="mt-10" v-if="data.group_class?.group_class_count > 0">
				<div class="text-neutral-600 font-semibold text-lg mb-4">
					Can thiệp lớp nhóm
				</div>
				<div class="grid grid-cols-1 xl:grid-cols-2 gap-6">
					<div
						class="
							bg-white
							shadow
							border-sm
							rounded-lg
							p-6
							flex
							items-center
							justify-between
						"
					>
						<div class="flex items-center justify-start gap-2">
							<div>
								<svg
									width="20"
									height="20"
									viewBox="0 0 20 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M7 9.75C6.31 9.75 5.75 10.31 5.75 11C5.75 11.69 6.31 12.25 7 12.25C7.69 12.25 8.25 11.69 8.25 11C8.25 10.31 7.69 9.75 7 9.75ZM13 9.75C12.31 9.75 11.75 10.31 11.75 11C11.75 11.69 12.31 12.25 13 12.25C13.69 12.25 14.25 11.69 14.25 11C14.25 10.31 13.69 9.75 13 9.75ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 9.71 2.02 9.42 2.05 9.14C4.41 8.09 6.28 6.16 7.26 3.77C9.07 6.33 12.05 8 15.42 8C16.2 8 16.95 7.91 17.67 7.74C17.88 8.45 18 9.21 18 10C18 14.41 14.41 18 10 18Z"
										fill="#6390C3"
									/>
									<path
										d="M8 13.9895C8 13.9895 9.86667 18.4895 12 13.9895H8Z"
										fill="#6390C3"
									/>
								</svg>
							</div>
							<div>Tổng số học sinh</div>
						</div>
						<div class="text-3xl font-bold text-neutral-600">
							{{
								data.group_class?.group_class_student_count || 0
							}}
						</div>
					</div>
					<div
						class="
							bg-white
							shadow
							border-sm
							rounded-lg
							p-6
							flex
							items-center
							justify-between
						"
					>
						<div class="flex items-center justify-start gap-2">
							<div>
								<svg
									width="20"
									height="20"
									viewBox="0 0 20 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M8.75 17.5C8.75 17.5 7.5 17.5 7.5 16.25C7.5 15 8.75 11.25 13.75 11.25C18.75 11.25 20 15 20 16.25C20 17.5 18.75 17.5 18.75 17.5H8.75Z"
										fill="#6390C3"
									/>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M13.75 10C15.8211 10 17.5 8.32107 17.5 6.25C17.5 4.17893 15.8211 2.5 13.75 2.5C11.6789 2.5 10 4.17893 10 6.25C10 8.32107 11.6789 10 13.75 10Z"
										fill="#6390C3"
									/>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M6.52045 17.5C6.34445 17.1449 6.25 16.7239 6.25 16.25C6.25 14.5557 7.09882 12.8132 8.66991 11.6C7.98262 11.3801 7.18137 11.25 6.25 11.25C1.25 11.25 0 15 0 16.25C0 17.5 1.25 17.5 1.25 17.5H6.52045Z"
										fill="#6390C3"
									/>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M5.625 10C7.35089 10 8.75 8.60089 8.75 6.875C8.75 5.14911 7.35089 3.75 5.625 3.75C3.89911 3.75 2.5 5.14911 2.5 6.875C2.5 8.60089 3.89911 10 5.625 10Z"
										fill="#6390C3"
									/>
								</svg>
							</div>
							<div>Tổng số lớp nhóm</div>
						</div>
						<div class="text-3xl font-bold text-neutral-600">
							{{ data.group_class?.group_class_count || 0 }}
						</div>
					</div>
				</div>
				<div class="mt-6">
					<div class="grid grid-cols-1 xl:grid-cols-2 gap-6">
						<div class="bg-white shadow border-sm rounded-lg">
							<div class="border-b">
								<div
									class="
										text-neutral-500
										font-semibold
										border-b
										p-6
									"
								>
									Tỉ lệ hoàn thành báo cáo
								</div>
								<div
									class="
										relative
										p-6
										flex
										items-center
										text-neutral-500
										gap-4
									"
								>
									<div class="h-full pb-9">
										<div
											style="height: 200px"
											class="
												flex flex-col
												items-start
												justify-between
											"
										>
											<div
												class="
													w-full
													rounded-full
													text-sm
													whitespace-nowrap
												"
											>
												<div>BC ngày</div>
												<div class="font-bold">
													{{
														data.report_stats
															?.group_class_stats
															?.group_lesson_report_completed_percent
													}}%
												</div>
											</div>
											<div
												class="
													w-full
													rounded-full
													text-sm
													whitespace-nowrap
												"
											>
												<div>BC tuần</div>
												<div class="font-bold">
													{{
														data.report_stats
															?.weekly_group_class_report_stats
															?.weekly_group_class_report_completed_percent
													}}%
												</div>
											</div>
											<div
												class="
													w-full
													rounded-full
													text-sm
													whitespace-nowrap
												"
											>
												<div>BCKH</div>
												<div class="font-bold">
													{{
														data.report_stats
															?.monthy_group_class_report_stats
															?.monthy_group_class_report_completed_percent
													}}%
												</div>
											</div>
										</div>
									</div>
									<div
										class="
											w-full
											grid grid-cols-10
											pt-6
											relative
										"
									>
										<div
											class="
												absolute
												l-0
												pt-8
												w-full
												flex flex-col
												items-start
												justify-between
											"
											style="height: 216px"
										>
											<div
												:style="{
													width:
														data.report_stats
															?.group_class_stats
															?.group_lesson_report_completed_percent +
														'%',
													background:
														$filters.tagResult(
															data.report_stats
																?.group_class_stats
																?.group_lesson_report_completed_percent
														)?.background,
												}"
												style="
													height: 15px;
													border-radius: 0 99px 99px 0;
												"
											></div>
											<div
												:style="{
													width:
														data.report_stats
															?.weekly_group_class_report_stats
															?.weekly_group_class_report_completed_percent +
														'%',
													background:
														$filters.tagResult(
															data.report_stats
																?.weekly_group_class_report_stats
																?.weekly_group_class_report_completed_percent
														)?.background,
												}"
												style="
													height: 15px;
													border-radius: 0 99px 99px 0;
												"
											></div>
											<div
												:style="{
													width:
														data.report_stats
															?.monthy_group_class_report_stats
															?.monthy_group_class_report_completed_percent +
														'%',
													background:
														$filters.tagResult(
															data.report_stats
																?.monthy_group_class_report_stats
																?.monthy_group_class_report_completed_percent
														)?.background,
												}"
												style="
													height: 15px;
													border-radius: 0 99px 99px 0;
												"
											></div>
										</div>
										<div v-for="i in 10" :key="i">
											<div
												class="
													border
													border-t-0
													border-b-0
													border-l
													border-neutral-200
												"
												:class="{
													'border-r-0': i !== 10,
												}"
												style="height: 200px"
											></div>
											<div
												class="
													text-neutral-500 text-sm
													mt-8
													font-semibold
													float-right
													-mr-2
												"
											>
												{{ i * 10 }}
											</div>
										</div>
									</div>
									<div class="h-full pb-8">
										<div
											style="height: 200px"
											class="
												flex flex-col
												items-start
												justify-between
											"
										>
											<div
												class="
													w-full
													text-sm
													py-1
													whitespace-nowrap
													font-bold
												"
											>
												{{
													data.report_stats
														?.group_class_stats
														?.completed_group_lesson_report_count
												}}/{{
													data.report_stats
														?.group_class_stats
														?.total_group_lesson_report_count
												}}
											</div>
											<div
												class="
													w-full
													text-sm
													py-1
													whitespace-nowrap
													font-bold
												"
											>
												{{
													data.report_stats
														?.weekly_group_class_report_stats
														?.completed_weekly_group_class_report_count
												}}/{{
													data.report_stats
														?.weekly_group_class_report_stats
														?.schedule_weekly_group_class_report_count
												}}
											</div>
											<div
												class="
													w-full
													text-sm
													py-1
													whitespace-nowrap
													font-bold
												"
											>
												{{
													data.report_stats
														?.monthy_group_class_report_stats
														?.completed_monthy_group_class_report_count
												}}/{{
													data.report_stats
														?.monthy_group_class_report_stats
														?.schedule_monthy_group_class_report_count
												}}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="bg-white shadow border-sm rounded-lg">
							<div class="border-b">
								<div
									class="
										text-neutral-500
										font-semibold
										border-b
										p-6
									"
								>
									Tỉ lệ phụ huynh xem báo cáo
								</div>
								<div
									class="
										relative
										p-6
										flex
										items-center
										text-neutral-500
										gap-4
									"
								>
									<div class="h-full pb-9">
										<div
											style="height: 200px"
											class="
												flex flex-col
												items-start
												justify-between
											"
										>
											<div
												class="
													w-full
													rounded-full
													text-sm
													whitespace-nowrap
												"
											>
												<div>BC ngày</div>
												<div class="font-bold">
													{{
														data.report_stats
															?.group_class_stats
															?.parent_read_group_lesson_report_percent
													}}%
												</div>
											</div>
											<div
												class="
													w-full
													rounded-full
													text-sm
													whitespace-nowrap
												"
											>
												<div>BC tuần</div>
												<div class="font-bold">
													{{
														data.report_stats
															?.weekly_group_class_report_stats
															?.total_parent_read_weekly_group_class_report
													}}%
												</div>
											</div>
											<div
												class="
													w-full
													rounded-full
													text-sm
													whitespace-nowrap
												"
											>
												<div>BCKH</div>
												<div class="font-bold">
													{{
														data.report_stats
															?.monthy_group_class_report_stats
															?.total_parent_read_monthy_group_class_report
													}}%
												</div>
											</div>
										</div>
									</div>
									<div
										class="
											w-full
											grid grid-cols-10
											pt-6
											relative
										"
									>
										<div
											class="
												absolute
												l-0
												pt-8
												w-full
												flex flex-col
												items-start
												justify-between
											"
											style="height: 216px"
										>
											<div
												:style="{
													width:
														data.report_stats
															?.group_class_stats
															?.parent_read_group_lesson_report_percent +
														'%',
													background:
														$filters.tagResult(
															data.report_stats
																?.group_class_stats
																?.parent_read_group_lesson_report_percent
														)?.background,
												}"
												style="
													height: 15px;
													border-radius: 0 99px 99px 0;
												"
											></div>
											<div
												:style="{
													width:
														data.report_stats
															?.weekly_group_class_report_stats
															?.parent_read_weekly_group_class_report_percent +
														'%',
													background:
														$filters.tagResult(
															data.report_stats
																?.weekly_group_class_report_stats
																?.parent_read_weekly_group_class_report_percent
														)?.background,
												}"
												style="
													height: 15px;
													border-radius: 0 99px 99px 0;
												"
											></div>
											<div
												:style="{
													width:
														data.report_stats
															?.monthy_group_class_report_stats
															?.parent_read_monthy_group_class_report_percent +
														'%',
													background:
														$filters.tagResult(
															data.report_stats
																?.monthy_group_class_report_stats
																?.parent_read_monthy_group_class_report_percent
														)?.background,
												}"
												style="
													height: 15px;
													border-radius: 0 99px 99px 0;
												"
											></div>
										</div>
										<div v-for="i in 10" :key="i">
											<div
												class="
													border
													border-t-0
													border-b-0
													border-l
													border-neutral-200
												"
												:class="{
													'border-r-0': i !== 10,
												}"
												style="height: 200px"
											></div>
											<div
												class="
													text-neutral-500 text-sm
													mt-8
													font-semibold
													float-right
													-mr-2
												"
											>
												{{ i * 10 }}
											</div>
										</div>
									</div>
									<div class="h-full pb-8">
										<div
											style="height: 200px"
											class="
												flex flex-col
												items-start
												justify-between
											"
										>
											<div
												class="
													w-full
													text-sm
													py-1
													whitespace-nowrap
													font-bold
												"
											>
												{{
													data.report_stats
														?.group_class_stats
														?.total_parent_read_group_lesson_report
												}}/{{
													data.report_stats
														?.group_class_stats
														?.total_group_lesson_report_count
												}}
											</div>
											<div
												class="
													w-full
													text-sm
													py-1
													whitespace-nowrap
													font-bold
												"
											>
												{{
													data.report_stats
														?.weekly_group_class_report_stats
														?.total_parent_read_weekly_group_class_report
												}}/{{
													data.report_stats
														?.weekly_group_class_report_stats
														?.schedule_weekly_group_class_report_count
												}}
											</div>
											<div
												class="
													w-full
													text-sm
													py-1
													whitespace-nowrap
													font-bold
												"
											>
												{{
													data.report_stats
														?.monthy_group_class_report_stats
														?.total_parent_read_monthy_group_class_report
												}}/{{
													data.report_stats
														?.monthy_group_class_report_stats
														?.schedule_monthy_group_class_report_count
												}}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="mt-10" v-if="data.day_care_count?.day_care_class_count > 0">
				<div class="text-neutral-600 font-semibold text-lg mb-4">
					Bán trú
				</div>
				<div class="grid grid-cols-1 xl:grid-cols-2 gap-6">
					<div
						class="
							bg-white
							shadow
							border-sm
							rounded-lg
							p-6
							flex
							items-center
							justify-between
						"
					>
						<div class="flex items-center justify-start gap-2">
							<div>
								<svg
									width="20"
									height="20"
									viewBox="0 0 20 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M7 9.75C6.31 9.75 5.75 10.31 5.75 11C5.75 11.69 6.31 12.25 7 12.25C7.69 12.25 8.25 11.69 8.25 11C8.25 10.31 7.69 9.75 7 9.75ZM13 9.75C12.31 9.75 11.75 10.31 11.75 11C11.75 11.69 12.31 12.25 13 12.25C13.69 12.25 14.25 11.69 14.25 11C14.25 10.31 13.69 9.75 13 9.75ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 9.71 2.02 9.42 2.05 9.14C4.41 8.09 6.28 6.16 7.26 3.77C9.07 6.33 12.05 8 15.42 8C16.2 8 16.95 7.91 17.67 7.74C17.88 8.45 18 9.21 18 10C18 14.41 14.41 18 10 18Z"
										fill="#65A30D"
									/>
									<path
										d="M8 13.9895C8 13.9895 9.86667 18.4895 12 13.9895H8Z"
										fill="#65A30D"
									/>
								</svg>
							</div>
							<div>Tổng số học sinh</div>
						</div>
						<div class="text-3xl font-bold text-neutral-600">
							{{ data.day_care_count?.day_care_students_count }}
						</div>
					</div>
					<div
						class="
							bg-white
							shadow
							border-sm
							rounded-lg
							p-6
							flex
							items-center
							justify-between
						"
					>
						<div class="flex items-center justify-start gap-2">
							<div>
								<svg
									width="20"
									height="20"
									viewBox="0 0 20 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M5.99666 20C6.21401 19.9999 6.4291 19.9559 6.62903 19.8706C6.82897 19.7854 7.00964 19.6607 7.16022 19.5039C7.3108 19.3472 7.42819 19.1617 7.50536 18.9585C7.58253 18.7553 7.61788 18.5386 7.60931 18.3214L7.33907 9.88249L8.5167 9.17284C8.8171 8.99077 9.06357 8.73196 9.23077 8.42305C9.39797 8.11413 9.47987 7.76625 9.46803 7.41518L9.23294 0.617447C9.22724 0.453467 9.15807 0.298112 9.04002 0.184158C8.92197 0.0702041 8.76427 0.00656322 8.60019 0.00666215C8.43688 0.00828381 8.28053 0.0729825 8.16383 0.187227C8.04713 0.301471 7.97912 0.456412 7.97402 0.619645L7.80924 4.85559C7.80781 4.98185 7.76112 5.1034 7.67766 5.19815C7.5942 5.2929 7.47951 5.35455 7.35445 5.37191C7.28497 5.37951 7.21467 5.37268 7.14795 5.35184C7.08124 5.33101 7.01954 5.29662 6.96674 5.25082C6.91393 5.20503 6.87116 5.14883 6.84109 5.08573C6.81102 5.02264 6.79431 4.95401 6.792 4.88416L6.62722 0.643812C6.62335 0.498377 6.57147 0.358308 6.47966 0.245442C6.38786 0.132576 6.26129 0.0532551 6.1197 0.0198446C6.03534 0.00562738 5.94919 0.00562738 5.86484 0.0198446C5.72324 0.0532551 5.59667 0.132576 5.50487 0.245442C5.41306 0.358308 5.36118 0.498377 5.35731 0.643812L5.19253 4.88416C5.19022 4.95401 5.17351 5.02264 5.14344 5.08573C5.11337 5.14883 5.0706 5.20503 5.01779 5.25082C4.96499 5.29662 4.9033 5.33101 4.83658 5.35184C4.76986 5.37268 4.69956 5.37951 4.63008 5.37191C4.50502 5.35455 4.39033 5.2929 4.30687 5.19815C4.22341 5.1034 4.17672 4.98185 4.17529 4.85559L4.00392 0.619645C3.99875 0.45336 3.92829 0.295802 3.80781 0.181078C3.68733 0.0663532 3.52652 0.00369344 3.36018 0.00666215C3.1961 0.00656322 3.0384 0.0702041 2.92034 0.184158C2.80229 0.298112 2.73312 0.453467 2.72742 0.617447L2.50112 7.41738C2.48929 7.76844 2.57118 8.11632 2.73838 8.42524C2.90558 8.73416 3.15206 8.99296 3.45245 9.17503L4.65205 9.89567L4.38181 18.3214C4.37323 18.5388 4.40865 18.7557 4.48596 18.959C4.56326 19.1623 4.68085 19.3479 4.83166 19.5047C4.98248 19.6615 5.16341 19.7862 5.36361 19.8713C5.5638 19.9564 5.77913 20.0002 5.99666 20Z"
										fill="#65A30D"
									/>
									<path
										d="M17.8125 8.24569C18.1252 7.6708 18.287 7.026 18.2827 6.37159C18.2673 4.22065 17.8784 0.0220559 14.7872 8.5179e-05C11.6959 -0.0218855 11.307 4.21187 11.2916 6.37159C11.2866 7.0258 11.4477 7.6706 11.7596 8.24569C12.0901 8.85577 12.5779 9.3663 13.1723 9.72431L13.4623 9.90008L13.1943 18.3214C13.1863 18.5355 13.2216 18.7489 13.298 18.9489C13.3744 19.149 13.4904 19.3316 13.639 19.4858C13.7876 19.64 13.9658 19.7627 14.1629 19.8465C14.3599 19.9303 14.5719 19.9735 14.7861 19.9735C15.0002 19.9735 15.2122 19.9303 15.4093 19.8465C15.6063 19.7627 15.7845 19.64 15.9331 19.4858C16.0817 19.3316 16.1977 19.149 16.2741 18.9489C16.3505 18.7489 16.3858 18.5355 16.3778 18.3214L16.1032 9.89568L16.3932 9.71992C16.9894 9.36403 17.4795 8.855 17.8125 8.24569Z"
										fill="#65A30D"
									/>
								</svg>
							</div>
							<div>Tổng số lớp</div>
						</div>
						<div class="text-3xl font-bold text-neutral-600">
							{{ data.day_care_count?.day_care_class_count }}
						</div>
					</div>
				</div>
				<div class="mt-6">
					<div class="grid grid-cols-1 xl:grid-cols-2 gap-6">
						<div class="bg-white shadow border-sm rounded-lg">
							<div class="border-b">
								<div
									class="
										text-neutral-500
										font-semibold
										border-b
										p-6
									"
								>
									Tỉ lệ hoàn thành báo cáo
								</div>
								<div
									class="
										relative
										p-6
										flex
										text-neutral-500
										gap-4
									"
								>
									<div class="h-full">
										<div
											class="
												flex flex-col
												items-start
												justify-between
											"
										>
											<div
												class="
													w-full
													rounded-full
													text-sm
													whitespace-nowrap
												"
											>
												<div>Bán trú</div>
												<div class="font-bold">
													{{
														data.report_stats
															?.day_care_report_stats
															?.lesson_report_completed_percent
													}}%
												</div>
											</div>
										</div>
									</div>
									<div
										class="
											w-full
											grid grid-cols-10
											relative
										"
									>
										<div
											class="
												absolute
												w-full
												flex flex-col
												items-start
												justify-between
												top-2
											"
										>
											<div
												:style="{
													width:
														data.report_stats
															?.day_care_report_stats
															?.lesson_report_completed_percent +
														'%',
													background:
														$filters.tagResult(
															data.report_stats
																?.day_care_report_stats
																?.lesson_report_completed_percent
														)?.background,
												}"
												style="
													height: 15px;
													border-radius: 0 99px 99px 0;
												"
											></div>
										</div>
										<div v-for="i in 10" :key="i">
											<div
												class="
													border
													border-t-0
													border-b-0
													border-l
													border-neutral-200
												"
												:class="{
													'border-r-0': i !== 10,
												}"
												style="height: 30px"
											></div>
											<div
												class="
													text-neutral-500 text-sm
													mt-2
													font-semibold
													float-right
													-mr-2
												"
											>
												{{ i * 10 }}
											</div>
										</div>
									</div>
									<div
										class="
											h-full
											text-sm
											whitespace-nowrap
											font-bold
											mt-1
										"
									>
										{{
											data.report_stats
												?.day_care_report_stats
												?.completed_lesson_report_count
										}}/{{
											data.report_stats
												?.day_care_report_stats
												?.total_lesson_report_count
										}}
									</div>
								</div>
							</div>
						</div>
						<div class="bg-white shadow border-sm rounded-lg">
							<div class="border-b">
								<div
									class="
										text-neutral-500
										font-semibold
										border-b
										p-6
									"
								>
									Tỉ lệ phụ huynh xem báo cáo
								</div>
								<div
									class="
										relative
										p-6
										flex
										text-neutral-500
										gap-4
									"
								>
									<div class="h-full">
										<div
											class="
												flex flex-col
												items-start
												justify-between
											"
										>
											<div
												class="
													w-full
													rounded-full
													text-sm
													whitespace-nowrap
												"
											>
												<div>Bán trú</div>
												<div class="font-bold">
													{{
														data.report_stats
															?.day_care_report_stats
															?.parent_read_report_percent
													}}%
												</div>
											</div>
										</div>
									</div>
									<div
										class="
											w-full
											grid grid-cols-10
											relative
										"
									>
										<div
											class="
												absolute
												w-full
												flex flex-col
												items-start
												justify-between
												top-2
											"
										>
											<div
												:style="{
													width:
														data.report_stats
															?.day_care_report_stats
															?.parent_read_report_percent +
														'%',
													background:
														$filters.tagResult(
															data.report_stats
																?.day_care_report_stats
																?.parent_read_report_percent
														)?.background,
												}"
												style="
													height: 15px;
													border-radius: 0 99px 99px 0;
												"
											></div>
										</div>
										<div v-for="i in 10" :key="i">
											<div
												class="
													border
													border-t-0
													border-b-0
													border-l
													border-neutral-200
												"
												:class="{
													'border-r-0': i !== 10,
												}"
												style="height: 30px"
											></div>
											<div
												class="
													text-neutral-500 text-sm
													mt-2
													font-semibold
													float-right
													-mr-2
												"
											>
												{{ i * 10 }}
											</div>
										</div>
									</div>
									<div
										class="
											h-full
											text-sm
											whitespace-nowrap
											font-bold
											mt-1
										"
									>
										{{
											data.report_stats
												?.day_care_report_stats
												?.total_parent_read_report
										}}/{{
											data.report_stats
												?.day_care_report_stats
												?.total_lesson_report_count
										}}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				class="
					mt-10
					grid grid-cols-1
					lg:grid-cols-5 lg:gap-10
					w-full
					gap-8
				"
			>
				<div class="flex flex-col col-span-3">
					<div class="flex items-center justify-between mb-4">
						<div class="text-neutral-600 font-semibold text-lg">
							Kho video
						</div>
					</div>
					<div class="flex items-center gap-4">
						<div
							class="
								w-full
								h-full
								text-neutral-500
								px-6
								py-4
								rounded-lg
								bg-white
								shadow
								border-sm
								flex flex-col
								items-start
								justify-between
							"
						>
							<div class="flex items-center justify-start gap-4">
								<div>
									<svg
										width="20"
										height="20"
										viewBox="0 0 20 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<g clip-path="url(#clip0_17923_10214)">
											<path
												d="M18.0543 2.5H1.946C1.69041 2.49995 1.43731 2.55273 1.20116 2.65531C0.965017 2.7579 0.750445 2.90829 0.569699 3.09789C0.388954 3.28749 0.245577 3.51259 0.147757 3.76034C0.0499361 4.00808 -0.000411697 4.27362 -0.000411693 4.54178V15.4582C-0.000552335 15.7265 0.0496917 15.9921 0.147449 16.24C0.245207 16.4879 0.388561 16.7131 0.569321 16.9028C0.75008 17.0926 0.9647 17.243 1.20092 17.3457C1.43713 17.4484 1.69032 17.5012 1.946 17.5011H18.0543C18.5704 17.5011 19.0654 17.286 19.4303 16.9031C19.7953 16.5202 20.0003 16.0009 20.0003 15.4593V4.54178C20.0003 4.00027 19.7953 3.48093 19.4303 3.09802C19.0654 2.71512 18.5704 2.5 18.0543 2.5ZM9.02692 4.05585H10.973C10.9966 4.05679 11.0195 4.06489 11.0389 4.07917C11.0583 4.09345 11.0733 4.11331 11.0822 4.13634V5.4702H8.95556V4.19736C8.94748 4.16867 8.95043 4.1378 8.96377 4.11136C8.9771 4.08492 8.99977 4.06499 9.02692 4.05585ZM3.91595 15.9232C3.88027 15.9232 3.82496 15.943 3.78857 15.943H1.96883C1.85965 15.943 1.80541 15.9232 1.80541 15.7839V14.5302H3.91524L3.91595 15.9232ZM3.89775 5.48892H1.93315C1.90781 5.49149 1.88245 5.4843 1.86179 5.4687V4.13634C1.87998 4.09629 1.91638 4.0566 1.95277 4.0566H3.86279C3.91738 4.03676 3.95377 4.07644 3.97197 4.13634V4.17603C3.99017 4.57435 3.99017 4.97267 3.99017 5.37062C3.97054 5.43014 3.95235 5.46983 3.89775 5.49004V5.48892ZM7.46266 15.9232C7.40807 15.9232 7.37167 15.943 7.33528 15.943H5.51554C5.44418 15.9629 5.38851 15.9232 5.35212 15.8434V14.5103H7.46194L7.46266 15.9232ZM7.46266 5.50876H5.53588C5.48128 5.50876 5.44525 5.4687 5.40885 5.42902V4.09591H7.3731C7.44446 4.07607 7.50048 4.11575 7.53688 4.19549V5.3504C7.54455 5.3819 7.5413 5.41524 7.5277 5.44445C7.51411 5.47367 7.49105 5.49686 7.46266 5.50988V5.50876ZM11.0094 15.9232C10.9548 15.9232 10.9184 15.943 10.8638 15.943H9.04405C8.93486 15.943 8.89847 15.9232 8.89847 15.7839V14.6496C8.89672 14.6024 8.90288 14.5553 8.91667 14.5103H11.0083L11.0094 15.9232ZM11.3961 10.5683L9.09828 12.0568C8.63871 12.3712 8.25906 12.1406 8.25906 11.5746V8.42992C8.25906 7.84292 8.63871 7.63327 9.09828 7.94774L11.3961 9.43621C11.8557 9.7518 11.8557 10.2538 11.3961 10.5683ZM14.5575 15.8648C14.5393 15.9045 14.5029 15.9441 14.4665 15.9441H12.5397C12.504 15.9441 12.4684 15.9045 12.4487 15.8648V14.5305H14.5575V15.8648ZM14.6485 4.19549C14.6128 4.59382 14.6303 4.9723 14.6303 5.3504C14.6303 5.43014 14.6303 5.49004 14.5393 5.49004H12.5372V4.05623H14.5197C14.5331 4.05243 14.547 4.05151 14.5608 4.05351C14.5745 4.05551 14.5877 4.0604 14.5996 4.06788C14.6115 4.07536 14.6218 4.08527 14.63 4.09704C14.6381 4.1088 14.6439 4.12217 14.6471 4.13634L14.6485 4.19549ZM18.086 15.9243H15.993V14.5305H18.0846L18.086 15.9243ZM18.1955 4.25539C18.1599 4.61366 18.177 4.99214 18.177 5.37025C18.177 5.44999 18.1592 5.50988 18.0678 5.50988H16.141C16.1157 5.51236 16.0905 5.50533 16.0697 5.49004V4.07607H18.0339C18.1053 4.05623 18.1613 4.09591 18.1977 4.17565L18.1955 4.25539Z"
												fill="#6390C3"
											/>
										</g>
										<defs>
											<clipPath id="clip0_17923_10214">
												<rect
													width="20"
													height="15"
													fill="white"
													transform="translate(0 2.5)"
												/>
											</clipPath>
										</defs>
									</svg>
								</div>
								<div>
									Dung lượng video đã dùng / Dung lượng video
									khả dụng
								</div>
							</div>
							<div
								class="text-4xl font-bold mt-4 text-neutral-600"
							>
								{{ data.media_stats?.used_size }}/
								{{ data.media_stats?.allocated_size }}
							</div>
						</div>
					</div>
				</div>
				<div class="flex flex-col col-span-2">
					<div class="flex items-center justify-between mb-4">
						<div class="text-neutral-600 font-semibold text-lg">
							Sinh nhật trong tháng
						</div>
					</div>
					<div class="flex items-start gap-4 h-full">
						<div
							class="
								w-full
								h-full
								text-neutral-500
								px-6
								py-4
								rounded-lg
								bg-white
								shadow
								border-sm
								flex flex-col
								items-start
								justify-between
							"
						>
							<div class="flex items-start justify-start gap-4">
								<div>
									<svg
										width="20"
										height="20"
										viewBox="0 0 20 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<g clip-path="url(#clip0_17921_10231)">
											<path
												d="M9.84848 5.45455C10.8576 5.45455 11.6667 4.63636 11.6667 3.63636C11.6667 3.29091 11.5757 2.97273 11.403 2.7L9.84848 0L8.29393 2.7C8.1212 2.97273 8.03029 3.29091 8.03029 3.63636C8.03029 4.63636 8.84848 5.45455 9.84848 5.45455ZM14.0303 14.5364L13.0576 13.5636L12.0757 14.5364C10.8939 15.7182 8.8212 15.7273 7.63029 14.5364L6.65757 13.5636L5.66666 14.5364C5.07575 15.1273 4.28484 15.4545 3.44847 15.4545C2.78484 15.4545 2.17575 15.2455 1.66666 14.9V19.0909C1.66666 19.5909 2.07575 20 2.57575 20H17.1212C17.6212 20 18.0303 19.5909 18.0303 19.0909V14.9C17.5212 15.2455 16.9121 15.4545 16.2485 15.4545C15.4121 15.4545 14.6212 15.1273 14.0303 14.5364ZM15.303 8.18182H10.7576V6.36364H8.93938V8.18182H4.39393C2.88484 8.18182 1.66666 9.4 1.66666 10.9091V12.3091C1.66666 13.2909 2.46666 14.0909 3.44847 14.0909C3.9212 14.0909 4.37575 13.9091 4.70302 13.5727L6.64847 11.6364L8.58484 13.5727C9.25757 14.2455 10.4303 14.2455 11.103 13.5727L13.0485 11.6364L14.9848 13.5727C15.3212 13.9091 15.7667 14.0909 16.2394 14.0909C17.2212 14.0909 18.0212 13.2909 18.0212 12.3091V10.9091C18.0303 9.4 16.8121 8.18182 15.303 8.18182Z"
												fill="#F1A267"
											/>
										</g>
										<defs>
											<clipPath id="clip0_17921_10231">
												<rect
													width="20"
													height="20"
													fill="white"
												/>
											</clipPath>
										</defs>
									</svg>
								</div>
								<div>Học sinh</div>
							</div>
							<div
								class="text-4xl font-bold mt-4 text-neutral-600"
							>
								{{
									data.birthday_stats.student_birthdays_count
								}}
							</div>
						</div>
						<div
							class="
								px-6
								py-4
								flex flex-col
								items-start
								justify-between
								rounded-lg
								bg-white
								shadow
								border-sm
								w-full
								h-full
								text-neutral-500
							"
						>
							<div class="flex items-start justify-start gap-4">
								<div>
									<svg
										width="20"
										height="20"
										viewBox="0 0 20 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<g clip-path="url(#clip0_17921_10238)">
											<path
												d="M9.84851 5.45455C10.8576 5.45455 11.6667 4.63636 11.6667 3.63636C11.6667 3.29091 11.5758 2.97273 11.4031 2.7L9.84851 0L8.29396 2.7C8.12123 2.97273 8.03032 3.29091 8.03032 3.63636C8.03032 4.63636 8.84851 5.45455 9.84851 5.45455ZM14.0303 14.5364L13.0576 13.5636L12.0758 14.5364C10.894 15.7182 8.82123 15.7273 7.63032 14.5364L6.6576 13.5636L5.66669 14.5364C5.07578 15.1273 4.28487 15.4545 3.44851 15.4545C2.78487 15.4545 2.17578 15.2455 1.66669 14.9V19.0909C1.66669 19.5909 2.07578 20 2.57578 20H17.1212C17.6212 20 18.0303 19.5909 18.0303 19.0909V14.9C17.5212 15.2455 16.9121 15.4545 16.2485 15.4545C15.4121 15.4545 14.6212 15.1273 14.0303 14.5364ZM15.3031 8.18182H10.7576V6.36364H8.93941V8.18182H4.39396C2.88487 8.18182 1.66669 9.4 1.66669 10.9091V12.3091C1.66669 13.2909 2.46669 14.0909 3.44851 14.0909C3.92123 14.0909 4.37578 13.9091 4.70305 13.5727L6.64851 11.6364L8.58487 13.5727C9.2576 14.2455 10.4303 14.2455 11.1031 13.5727L13.0485 11.6364L14.9849 13.5727C15.3212 13.9091 15.7667 14.0909 16.2394 14.0909C17.2212 14.0909 18.0212 13.2909 18.0212 12.3091V10.9091C18.0303 9.4 16.8121 8.18182 15.3031 8.18182Z"
												fill="#86A8D0"
											/>
										</g>
										<defs>
											<clipPath id="clip0_17921_10238">
												<rect
													width="20"
													height="20"
													fill="white"
												/>
											</clipPath>
										</defs>
									</svg>
								</div>
								<div>Giáo viên</div>
							</div>
							<div
								class="text-4xl font-bold mt-4 text-neutral-600"
							>
								{{ data.birthday_stats.staff_birthdays_count }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="mt-10 grid grid-cols-1 lg:gap-10 w-full">
				<div class="flex flex-col col-span-3">
					<div class="flex items-center justify-between mb-4">
						<div class="text-neutral-600 font-semibold text-lg">
							Học phí
						</div>
					</div>
					<div
						class="flex items-center gap-4"
						v-if="data?.tuition_stats"
					>
						<div
							class="
								w-full
								h-full
								text-neutral-500
								px-6
								py-4
								rounded-lg
								bg-white
								shadow
								border-sm
								flex flex-col
								items-start
								justify-between
							"
						>
							<div
								class="flex items-center justify-between w-full"
							>
								<div
									class="
										flex
										items-center
										justify-start
										gap-4
									"
								>
									<div>
										<svg
											width="20"
											height="20"
											viewBox="0 0 20 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M13.8194 5H6.18089C6.18089 5 0.833313 9.73633 0.833313 15.2637C0.833313 18.4206 3.13294 20 4.65259 20H15.3474C16.8734 20 19.1666 18.4204 19.1666 15.2637C19.1666 9.73633 13.8191 5 13.8191 5H13.8194ZM10.7632 15.9725V17.2366H9.23713L9.23699 15.9767C8.11226 15.7606 7.40574 15.0433 7.35561 14.0018H8.67893C8.74368 14.5484 9.27682 14.9007 10.0482 14.9007C10.7589 14.9007 11.2628 14.5442 11.2628 14.0365C11.2628 13.6043 10.9367 13.3579 10.134 13.1722L9.28309 12.9843C8.09143 12.7271 7.50609 12.0854 7.50609 11.0547C7.50609 10.0241 8.17091 9.28068 9.2287 9.03651V7.76366H10.7547V9.03848C11.7874 9.27617 12.4753 10.0043 12.5087 10.9831L11.2314 10.9832C11.1667 10.4495 10.6857 10.0931 10.0252 10.0931C9.36462 10.0931 8.88791 10.4215 8.88791 10.9358C8.88791 11.3529 9.19939 11.5841 9.96657 11.7612L10.7547 11.934C12.0696 12.2192 12.6361 12.7983 12.6361 13.855C12.6363 14.985 11.9338 15.7413 10.7632 15.9725L10.7632 15.9725Z"
												fill="#F0BB4F"
											/>
											<path
												d="M13.474 0.830102H11.5536C11.1569 0.3017 10.5924 0 10.0001 0C9.40778 0 8.8433 0.301716 8.44659 0.830102H6.52621C6.2965 0.831217 6.08217 0.968534 5.95325 1.19681C5.82433 1.4251 5.79754 1.71518 5.88163 1.97198L6.5262 4.16667H13.4738L14.1183 1.97198C14.2024 1.71519 14.1756 1.42511 14.0467 1.19681C13.9178 0.968521 13.7035 0.831219 13.4737 0.830102H13.474Z"
												fill="#F0BB4F"
											/>
										</svg>
									</div>
									<div>Học phí thu được</div>
								</div>
								<div class="text-neutral-600 font-semibold">
									{{
										data.tuition_stats
											?.paid_tuition_count || 0
									}}/{{
										data.tuition_stats
											?.total_tuition_count || 0
									}}
									học sinh
								</div>
							</div>
							<div
								class="
									relative
									py-6
									flex
									text-neutral-500
									gap-10
									w-full
								"
							>
								<div class="h-full">
									<div
										class="
											flex flex-col
											items-start
											justify-between
										"
									>
										<div
											class="
												w-full
												rounded-full
												text-sm
												whitespace-nowrap
											"
										>
											<div class="font-bold">
												{{
													data.tuition_stats
														?.price_paid_percent ||
													0
												}}%
											</div>
										</div>
									</div>
								</div>
								<div class="w-full grid grid-cols-10 relative">
									<div
										class="
											absolute
											w-full
											flex flex-col
											items-start
											justify-between
											top-2
										"
									>
										<div
											:style="{
												width:
													data.tuition_stats
														?.price_paid_percent +
													'%',
												background: $filters.tagResult(
													data.tuition_stats
														?.price_paid_percent
												)?.background,
											}"
											style="
												height: 15px;
												border-radius: 0 99px 99px 0;
											"
										></div>
									</div>
									<div v-for="i in 10" :key="i">
										<div
											class="
												border
												border-t-0
												border-b-0
												border-l
												border-neutral-200
											"
											:class="{
												'border-r-0': i !== 10,
											}"
											style="height: 30px"
										></div>
										<div
											class="
												text-neutral-500 text-sm
												mt-2
												font-semibold
												float-right
												-mr-2
											"
										>
											{{ i * 10 }}
										</div>
									</div>
								</div>
								<div
									class="
										h-full
										text-2xl
										whitespace-nowrap
										font-semibold
										mt-1
									"
								>
									{{
										$filters.priceFormat(
											data.tuition_stats
												?.total_tuition_price_paid
										)
									}}/{{
										$filters.priceFormat(
											data.tuition_stats
												?.total_tuition_price
										)
									}}
								</div>
							</div>
						</div>
					</div>
					<div class="flex items-center gap-4" v-else>
						<div
							class="
								w-full
								h-full
								text-neutral-500
								px-6
								py-4
								rounded-lg
								bg-white
								shadow
								border-sm
								flex flex-col
								items-center
								justify-center
							"
						>
							<img
								style="width: 140px; height: 140px"
								src="@/assets/images/illustrations/not_found.png"
								alt=""
							/>

							<div class="text-gray-400 mt-4 text-center">
								Sử dụng tính năng Quản lý học phí của Luca để
								xem được thống kê học phí của trung tâm, cùng
								với trình tính học phí tự động, nhanh chóng, và
								linh hoạt.
							</div>
							<div class="flex items-center gap-2 mt-4">
								<button
									style="height: 46px"
									type="button"
									class="button-p px-4 py-3"
									@click="$router.push(`/tuition/setting`)"
								>
									Quản lý học phí
								</button>
								<a
									class="luca-button w-max whitespace-nowrap"
									target="_blank"
									href="https://wiki.luca.education/web-danh-cho-tri-lieu-vien/quan-ly-hoc-phi"
									>Tìm hiểu thêm</a
								>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import dayjs from 'dayjs';
import { $api } from '@/services';
import BaseStackedBarChart from '@/views/dashboard/chart/BaseStackedBarChart.vue';
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import ChooseCenter from '@/components/elements/chooseCenter/ChooseCenter.vue';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';

export default {
	name: 'Dashboard',
	components: {
		BaseStackedBarChart,
		DaIcon,
		ChooseCenter,
		DaModalFrame,
	},
	data() {
		return {
			date: {
				month: new Date().getMonth(),
				year: new Date().getFullYear(),
			},
			modalIsOpen: false,
			listCity: [],
			assessmentStats: {
				assessmentByResult: {
					data: [],
					xAxis: [],
				},
			},
			chartOptions_1: {
				chart: {
					type: 'radialBar',
				},
				plotOptions: {
					radialBar: {
						hollow: {
							size: '60%',
						},
						dataLabels: {
							name: {
								show: false,
							},
							value: {
								offsetY: 4,
								color: '#48566A',
								fontSize: '24px',
								show: true,
								fontWeight: 'bold',
							},
						},
					},
				},
				fill: {
					colors: '#2AA797',
				},
				stroke: {
					lineCap: 'round',
				},
			},
			chartOptions_2: {
				chart: {
					type: 'radialBar',
				},
				plotOptions: {
					radialBar: {
						hollow: {
							size: '60%',
						},
						dataLabels: {
							name: {
								show: false,
							},
							value: {
								offsetY: 4,
								color: '#48566A',
								fontSize: '24px',
								show: true,
								fontWeight: 'bold',
							},
						},
					},
				},
				fill: {
					colors: '#F0BB4F',
				},
				stroke: {
					lineCap: 'round',
				},
			},
			chartOptions_3: {
				chart: {
					type: 'radialBar',
				},
				plotOptions: {
					radialBar: {
						hollow: {
							size: '60%',
						},
						dataLabels: {
							name: {
								show: false,
							},
							value: {
								offsetY: 4,
								color: '#48566A',
								fontSize: '24px',
								show: true,
								fontWeight: 'bold',
							},
						},
					},
				},
				fill: {
					colors: '#E37056',
				},
				stroke: {
					lineCap: 'round',
				},
			},
			chartOptions_4: {
				chart: {
					type: 'radialBar',
				},
				plotOptions: {
					radialBar: {
						hollow: {
							size: '60%',
						},
						dataLabels: {
							name: {
								show: false,
							},
							value: {
								offsetY: 4,
								color: '#48566A',
								fontSize: '24px',
								show: true,
								fontWeight: 'bold',
							},
						},
					},
				},
				fill: {
					colors: '#86A8D0',
				},
				stroke: {
					lineCap: 'round',
				},
			},
			data: {
				assessment_stats: {
					assessment_less_than_fifty_percent: 0,
					assessment_less_than_seventy_percent: 0,
					assessment_less_than_sixty_percent: 0,
					assessment_more_than_seventy_percent: 0,
				},
				day_care_count: {
					day_care_class_count: 1,
					day_care_students_count: 3,
				},
				birthday_stats: {
					staff_birthdays_count: 0,
					student_birthdays_count: 7,
				},
				report_stats: {
					day_care_report_stats: {
						completed_lesson_report_count: 0,
						lesson_report_completed_percent: 0,
						total_lesson_report_count: 0,
					},
					lesson_report_stats: {
						completed_lesson_report_count: 0,
						completed_lesson_report_percent: 0,
						total_lesson_report_count: 0,
					},
					monthly_report_stats: {
						completed_monthly_report_count: 0,
						monthly_report_completed_percent: 0,
						schedule_monthly_report_count: 9,
					},

					weekly_report_stats: {
						completed_weekly_report_count: 0,
						schedule_weekly_report_count: 9,
						weekly_report_completed_percent: 0,
					},
				},
				session_stats: {
					total_non_cancelled_hours: '2.5',
					total_scheduled_hours: '3',
					total_unscheduled_hours: '0.5',
				},
				staff_stats: {
					active_staff_count: 9,
					closed_staff_count: 0,
				},
				student_stats: {
					active_student_count: 8,
					closed_student_count: 0,
					just_joined_student_count: 0,
				},
				tuition_stats: {
					paid_tuition_count: 1,
					total_tuition_count: 2,
				},
			},
			selectedOrg: null,
			listCenter: [],
			studentCount: 0,
			orgCount: 0,
		};
	},

	computed: {
		dateTitle() {
			return dayjs(new Date(this.date.year, this.date.month, 1)).format(
				'MM/YYYY'
			);
		},
		datePayload() {
			return dayjs(new Date(this.date.year, this.date.month, 10)).format(
				'YYYY-MM-DD'
			);
		},

		isEnableSchedule() {
			return this.$store.state.profile.current_org
				.enable_personal_schedule;
		},

		hasDaycare() {
			return (
				this.$store.state.profile.current_org.has_day_care &&
				this.$store.state.profile.current_org.exists_day_care_class
			);
		},
		orgName() {
			return this.$store.state.profile.current_org.name;
		},
	},

	watch: {
		date: {
			deep: true,
			handler(value) {
				if (value) {
					this.selectedOrg = null;
					this.fetchDashboard();
				}
			},
		},
	},

	created() {
		this.fetchDashboard();
		this.fetchDashboardChart();
	},

	methods: {
		async fetchDashboardChart() {
			try {
				const { data } = await $api.leader.fetchDashboardChart({
					date: this.datePayload,
					stats: ['assessment'],
				});
				const { assessment_stats } = data;
				this.setAssessmentStats(assessment_stats);
			} catch (err) {
				await this.$store.dispatch('setAlertMessage', {
					message: 'Có lỗi xảy ra, vui lòng thử lại.',
					type: 'danger',
				});
			}
		},

		setAssessmentStats(assessment_stats) {
			let result = assessment_stats.assessment_by_result.data.map(
				(item) => ({
					...item,
					data: item.data.slice(0, 5),
				})
			);
			let arr = assessment_stats.assessment_by_result.x_axis.slice(0, 5);
			this.assessmentStats = {
				assessmentByResult: {
					data: result,
					xAxis: arr,
				},
			};
		},

		colorByIndex(index) {
			const hue = (index * 47) % 360;
			return {
				solid: `hsl(${hue}, 70%, 50%, 0.6)`,
				light: `hsla(${hue}, 70%, 50%, 0.05)`,
			};
		},
		fetchData(value) {
			if (value.org_id) {
				this.fetchDashboardOrg(value);
			} else this.fetchDashboard();
		},
		async fetchDashboard() {
			try {
				const { data } = await $api.leader.fetchDashboard({
					date: this.datePayload,
				});
				this.data = data;
				this.listCity = Object.entries(
					this.data.orgs_group_by_city
				).map(([city, arr]) => ({
					city,
					number: arr.length,
				}));
				this.listCenter = this.data.assessment_chart;
				this.studentCount =
					this.data.student_stats?.active_student_count;
				this.orgCount = this.data.number_of_orgs;
				this.modalIsOpen = false;
			} catch (err) {
				await this.$store.dispatch('setAlertMessage', {
					message: 'Cõ lỗi xảy ra, vui lòng thử lại.',
					type: 'danger',
				});
			}
		},

		async fetchDashboardOrg(value) {
			try {
				if (value) this.selectedOrg = value;
				this.modalIsOpen = false;
				const { data } = await $api.leader.fetchDashboardOrg(
					{
						date: this.datePayload,
					},
					value ? value.org_id : ''
				);
				this.data = data;
			} catch (err) {
				await this.$store.dispatch('setAlertMessage', {
					message: 'Cõ lỗi xảy ra, vui lòng thử lại.',
					type: 'danger',
				});
			}
		},
	},
};
</script>
